import React, { ReactNode } from 'react';
import { CardBody, CardTitle, CardWrapper } from './styled';
import CardFooter from 'components/CardFooter/CardFooter';

interface CardProps {
  title?: string;
  footer?: ReactNode;
}

export const Card: React.FC<CardProps> = ({ children, title, footer }) => {
  return (
    <CardWrapper>
      <CardBody>
        <div className="w-full">
          {title && <CardTitle>{title}</CardTitle>}
          {children}
        </div>
      </CardBody>
      {footer && <CardFooter>{footer}</CardFooter>}
    </CardWrapper>
  );
};

export default Card;
